/* Slider dos tres itens de confianca do brand story das collection pages.
   Como na referencia: so aparece abaixo de 750px, com pontos por baixo. */
(function () {
  function setup(root) {
    if (root.dataset.leaStoryReady === '1') return;
    root.dataset.leaStoryReady = '1';

    var track = root.querySelector('[data-track]');
    var dots = [].slice.call(root.querySelectorAll('.lea-story-r__dot'));
    if (!track || !dots.length) return;

    var index = 0;
    var timer = null;

    function go(i) {
      index = (i + dots.length) % dots.length;
      track.style.transform = 'translateX(' + (-100 * index) + '%)';
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === index);
      }
    }

    function start() {
      stop();
      timer = setInterval(function () { go(index + 1); }, 5000);
    }
    function stop() { if (timer) clearInterval(timer); }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); start(); });
    });

    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      x0 = null;
      start();
    }, { passive: true });

    go(0);
    start();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-lea-story-slider]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
  setTimeout(boot, 1500);
})();
